import { IOption } from "../../../components/Dropdown/Dropdown";

export function formatRunDate(date: Date | null): string {
  if (!date) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function parseRunDate(value: string): Date | null {
  if (!value) return null;
  const [year, month, day] = value.split("-").map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day, 12, 0, 0);
}

export function runOptions(items: { value: string; label: string }[], placeholder?: string): IOption[] {
  const mapped = items.map((item) => ({ id: item.value, value: item.label }));
  return placeholder ? [{ id: "", value: placeholder }, ...mapped] : mapped;
}

export function runOption(options: IOption[], id: string): IOption {
  return options.find((option) => option.id === id) || options[0];
}
